import * as React from "react";
import { useIsMobile } from "../hooks/useIsMobile.js";

interface ResponsiveProps {
  desktop: React.ReactNode;
  mobile: React.ReactNode;
}

/**
 * Renders `desktop` until useIsMobile() flips to true, then `mobile`.
 *
 * Use ONLY on client-rendered routes — never on the prerendered marketing
 * routes (`/`, `/about`, `/privacy`, `/terms`), which get their mobile layout
 * from a CSS-only `@media` path in mobile-field.css to avoid a hydration flash.
 *
 * Mobile route components are `React.lazy()`-wrapped at the call site in
 * App.tsx, so a desktop visitor never downloads the mobile chunk (and vice
 * versa). React only mounts the returned node, so the inactive tree is never
 * rendered — the desktop bundle stays byte-for-byte unchanged.
 */
export function Responsive({
  desktop,
  mobile,
}: ResponsiveProps): React.ReactElement {
  return <>{useIsMobile() ? mobile : desktop}</>;
}
